// Privacy Policy page
import { createElement } from '@/utils/dom'
import { router } from '@/utils/router'
import { Footer } from '@/components/footer'

export class PoliticaDePrivacidadePage {

  async render(): Promise<HTMLElement> {
    const page = createElement('div', { className: 'legal-page' })

    // Navigation
    page.appendChild(this.createNavigation())
    
    // Main content
    page.appendChild(this.createMainContent())
    
    // Footer
    const footer = new Footer()
    page.appendChild(footer.render())

    return page
  }

  private createNavigation(): HTMLElement {
    const nav = createElement('nav', { className: 'nav' })
    
    nav.innerHTML = `
      <div class="container">
        <div class="nav-container">
          <a href="#" class="nav-logo">
            🗺️ Mapas KM
          </a>
          <ul class="nav-menu">
            <li><a href="/" class="nav-link">Início</a></li>
            <li><a href="/pricing" class="nav-link">Preços</a></li>
            <li><a href="/funcionalidades" class="nav-link">Funcionalidades</a></li>
            <li><a href="/register" class="nav-cta">Começar Grátis →</a></li>
          </ul>
        </div>
      </div>
    `

    // Add click handlers
    nav.addEventListener('click', (e) => {
      e.preventDefault()
      const target = e.target as HTMLElement
      
      if (target.tagName === 'A') {
        const href = target.getAttribute('href')
        if (href && href !== '#') {
          router.navigate(href)
        }
      }
    })

    return nav
  }

  private createMainContent(): HTMLElement {
    const main = createElement('main', { className: 'legal-content' })
    
    main.innerHTML = `
      <div class="container">
        <div class="legal-header">
          <h1>Política de Privacidade</h1>
          <p class="legal-subtitle">Última atualização: 15 de agosto de 2025</p>
        </div>

        <div class="legal-body">
          <section class="legal-section">
            <h2>1. Informações Gerais</h2>
            
            <h3>1.1 Responsável pelo Tratamento</h3>
            <p><strong>ANTONIO LOZADA LDA</strong><br>
            NIF: 517712261<br>
            Email: antoniolozadalda@gmail.com<br>
            Morada: RUA DO ALECRIM 21 6 ESQ</p>

            <h3>1.2 Delegado de Proteção de Dados</h3>
            <p>Para questões relacionadas com proteção de dados, contacte: antoniolozadalda@gmail.com</p>

            <h3>1.3 Âmbito</h3>
            <p>Esta Política de Privacidade aplica-se ao processamento de dados pessoais através da plataforma Mapas KM, em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD).</p>
          </section>

          <section class="legal-section">
            <h2>2. Dados Pessoais Recolhidos</h2>
            
            <h3>2.1 Dados de Registo da Empresa</h3>
            <ul>
              <li>Nome da empresa</li>
              <li>NIF (Número de Identificação Fiscal)</li>
              <li>Email de contacto da empresa</li>

              <li>Morada da empresa (quando fornecida)</li>
            </ul>

            <h3>2.2 Dados do Utilizador Administrador</h3>
            <ul>
              <li>Nome completo</li>
              <li>Email pessoal/profissional</li>

              <li>Cargo na empresa (quando fornecido)</li>
            </ul>

            <h3>2.3 Dados de Utilização do Serviço</h3>
            <ul>
              <li>Endereços de partida para geração de rotas</li>
              <li>Dados de veículos (matrícula, ano, tipo)</li>
              <li>Histórico de relatórios gerados</li>
              <li>Logs de acesso e utilização</li>
              <li>Dados de sessão e autenticação</li>
            </ul>

            <h3>2.4 Dados Técnicos</h3>
            <ul>
              <li>Endereço IP</li>
              <li>Tipo de navegador e versão</li>
              <li>Sistema operativo</li>
              <li>Cookies de sessão</li>
              <li>Timestamps de atividade</li>
            </ul>
          </section>

          <section class="legal-section">
            <h2>3. Finalidades do Tratamento</h2>
            
            <h3>3.1 Execução do Contrato</h3>
            <ul>
              <li>Fornecimento do serviço de geração de rotas</li>
              <li>Processamento de pagamentos</li>
              <li>Suporte técnico e atendimento ao cliente</li>
              <li>Comunicações relacionadas com o serviço</li>
            </ul>

            <h3>3.2 Interesse Legítimo</h3>
            <ul>
              <li>Melhoria da qualidade do serviço</li>
              <li>Análise de utilização para otimização</li>
              <li>Prevenção de fraude e segurança</li>
              <li>Desenvolvimento de novas funcionalidades</li>
            </ul>

            <h3>3.3 Cumprimento de Obrigações Legais</h3>
            <ul>
              <li>Conservação de registos conforme legislação fiscal portuguesa</li>
              <li>Cumprimento de obrigações de auditoria</li>
              <li>Resposta a solicitações de autoridades competentes</li>
            </ul>
          </section>

          <section class="legal-section">
            <h2>4. Base Legal do Tratamento</h2>
            
            <h3>4.1 Consentimento (Artigo 6.º(1)(a) RGPD)</h3>
            <ul>
              <li>Newsletter e comunicações promocionais</li>
              <li>Cookies não essenciais</li>
              <li>Funcionalidades opcionais</li>
            </ul>

            <h3>4.2 Execução de Contrato (Artigo 6.º(1)(b) RGPD)</h3>
            <ul>
              <li>Prestação do serviço Mapas KM</li>
              <li>Processamento de pagamentos</li>
              <li>Suporte técnico</li>
            </ul>

            <h3>4.3 Interesse Legítimo (Artigo 6.º(1)(f) RGPD)</h3>
            <ul>
              <li>Logs de segurança</li>
              <li>Análises de performance (anonimizadas)</li>
              <li>Prevenção de fraude</li>
            </ul>

            <h3>4.4 Obrigação Legal (Artigo 6.º(1)(c) RGPD)</h3>
            <ul>
              <li>Conservação de registos fiscais</li>
              <li>Cumprimento de legislação portuguesa</li>
            </ul>
          </section>

          <section class="legal-section">
            <h2>5. Direitos dos Titulares de Dados</h2>
            
            <h3>5.1 Direito de Acesso (Artigo 15.º RGPD)</h3>
            <p>Pode solicitar uma cópia de todos os dados pessoais que processamos.</p>

            <h3>5.2 Direito de Retificação (Artigo 16.º RGPD)</h3>
            <p>Pode corrigir dados imprecisos ou incompletos através do painel de controlo ou contactando-nos.</p>

            <h3>5.3 Direito de Apagamento (Artigo 17.º RGPD)</h3>
            <p>Pode solicitar a eliminação dos seus dados, sujeito a obrigações legais de conservação.</p>

            <h3>5.4 Exercício de Direitos</h3>
            <p>Para exercer qualquer direito, contacte: <strong>privacy@mapaskm.pt</strong><br>
            Responderemos no prazo de 30 dias.</p>
          </section>

          <section class="legal-section">
            <h2>6. Segurança de Dados</h2>
            
            <h3>6.1 Medidas Técnicas</h3>
            <ul>
              <li>Cifragem TLS 1.3 para dados em trânsito</li>
              <li>Cifragem AES-256 para dados em repouso</li>
              <li>Autenticação JWT com tokens seguros</li>
              <li>Hashing de passwords com Argon2</li>
            </ul>

            <h3>6.2 Medidas Organizacionais</h3>
            <ul>
              <li>Acesso restrito por funções</li>
              <li>Formação regular da equipa</li>
              <li>Auditorias de segurança periódicas</li>
              <li>Planos de resposta a incidentes</li>
            </ul>
          </section>

          <section class="legal-section">
            <h2>7. Partilha de Dados</h2>
            
            <h3>7.1 Prestadores de Serviços</h3>
            <p>Partilhamos dados com:</p>
            <ul>
              <li><strong>Google Maps API</strong>: Para cálculos de distância e geocodificação</li>
              <li><strong>OpenStreetMap</strong>: Para validação de localizações</li>
              <li><strong>Processadores de pagamento</strong>: Para transações financeiras</li>
              <li><strong>Fornecedores de infraestrutura</strong>: Para alojamento e backup</li>
            </ul>

            <h3>7.2 Não Partilha Comercial</h3>
            <p class="highlight"><strong>Nunca vendemos ou alugamos dados pessoais a terceiros para fins comerciais.</strong></p>
          </section>

          <section class="legal-section">
            <h2>8. Retenção de Dados</h2>
            <ul>
              <li><strong>Dados de conta ativa</strong>: Durante a vigência da subscrição</li>
              <li><strong>Dados após cancelamento</strong>: 90 dias para possível recuperação</li>
              <li><strong>Registos fiscais</strong>: 5 anos (obrigação legal portuguesa)</li>
              <li><strong>Logs de segurança</strong>: 1 ano</li>
            </ul>
          </section>

          <section class="legal-section">
            <h2>9. Contacto</h2>
            
            <h3>9.1 Proteção de Dados</h3>
            <p><strong>Email:</strong> antoniolozadalda@gmail.com<br>
            <strong>Assunto:</strong> "Pedido RGPD - [Tipo de Pedido]"</p>

            <h3>9.2 Autoridade de Controlo</h3>
            <p><strong>Comissão Nacional de Proteção de Dados (CNPD)</strong><br>
            Website: www.cnpd.pt<br>
            Email: geral@cnpd.pt</p>
          </section>

          <div class="legal-footer">
            <p>Esta Política de Privacidade foi elaborada em conformidade com o RGPD e legislação portuguesa aplicável.</p>
          </div>
        </div>
      </div>
    `

    // Add click handlers for internal links
    main.addEventListener('click', (e) => {
      e.preventDefault()
      const target = e.target as HTMLElement
      
      if (target.tagName === 'A' && target.classList.contains('legal-link')) {
        const href = target.getAttribute('href')
        if (href) {
          router.navigate(href)
        }
      }
    })

    return main
  }
}
